import React, { useEffect } from "react";
import bannerImage from "../images/banner.jpeg";
import logoImage from "../images/logo.png";
import AOS from "aos";
import "aos/dist/aos.css";

const Header = ({ businessName, businessDescription }) => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 50,
    });
  }, []);

  return (
    <div className="pb-8">
      <div className="relative">
        <div className="h-[200px] lg:h-[300px] w-full overflow-hidden rounded-b-3xl shadow-sm">
          <img
            className="w-full h-full object-cover transition-transform hover:scale-105 duration-1000"
            src={bannerImage}
            alt="banner"
          />
        </div>

        <img
          className="relative mx-auto mt-[-60px] w-32 h-32 lg:w-40 lg:h-40 object-cover rounded-full border-4 border-white shadow-lg z-10"
          src={logoImage}
          alt="logo"
          data-aos="fade-up"
          data-aos-delay="200"
        />
      </div>

      <div className="mt-6 space-y-2 text-center">
        <h1
          data-aos="fade-up"
          data-aos-delay="300"
          className="text-3xl font-bold tracking-tight text-gray-900"
        >
          {businessName}
        </h1>
        <h2
          data-aos="fade-up"
          data-aos-delay="400"
          className="text-lg font-medium text-gray-500"
        >
          {businessDescription}
        </h2>
      </div>
    </div>
  );
};

export default Header;
